import {
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { SecondayCaregiverTwoIntro } from '../../../components/FormDescriptions/SecondayCaregiverIntros';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['secondary-two-intro-title'];
const INPUT_LABEL = content['secondary-two-apply-label'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, SecondayCaregiverTwoIntro),
    'view:hasSecondaryCaregiverTwo': yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    properties: {
      'view:hasSecondaryCaregiverTwo': yesNoSchema,
    },
  },
};
